/**
 * IOL power-calculation formula catalog (`BACKLOG.md` M10) — metadata only. This module names which
 * formula a cataract surgical plan's biometry was run through; it does not implement any of them. See
 * `db/schema/ophthalmology.ts`'s header for why: each is a proprietary regression/optical model, and an
 * incorrect from-scratch reimplementation is a direct patient-safety risk (a wrong IOL power is a real,
 * irreversible postoperative refractive surprise) — the actual calculation happens on the surgeon's own
 * biometer device or a licensed calculator (e.g. the ASCRS online calculator), never in this
 * application.
 */

export const IOL_FORMULAS = ['srk_t', 'hoffer_q', 'holladay', 'barrett_universal_ii'] as const;
export type IolFormula = (typeof IOL_FORMULAS)[number];

export function isIolFormula(value: string): value is IolFormula {
  return (IOL_FORMULAS as readonly string[]).includes(value);
}

const IOL_FORMULA_LABELS: Readonly<Record<IolFormula, string>> = {
  srk_t: 'SRK/T',
  hoffer_q: 'Hoffer Q',
  holladay: 'Holladay',
  barrett_universal_ii: 'Barrett Universal II',
};

export function iolFormulaLabel(formula: IolFormula): string {
  return IOL_FORMULA_LABELS[formula];
}
